import React from "react";
import { Connector, subscribe } from "react-mqtt-client";
//import { Connector, subscribe } from "mqtt";

export default function App() {
  return (
    <Connector
      mqttProps={{
        //url: "wss://test.mosquitto.org:8081",
        url: "wss://boxdin.ddns.net:15676",
        options: { protocol: "wss", username: "test2", password: "test" } // see MQTTjs options
      }}
    >
      <Connected />
    </Connector>
  );
}

const MessageList = (props) => {
  const { mqtt, data } = props;
  // here mqtt is the connection object
  // and data is the object that has the incoming data from the broker

  return (
    <React.Fragment>
      {data.map((d, i) => (
        <p>{`${JSON.stringify(d, null, 4)}`}</p>
      ))}
    </React.Fragment>
  );
};

// name the below component anything you want
const Connected = subscribe({ topic: "#" })(MessageList);
